import {prospectusUrl} from '../api';

const forgottenPassword = ({email}) => async(dispatch) => {

    // Run the await on recaptcha.
    const response = await fetch( prospectusUrl() + 'forgotten', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            email: email
        }),
    })

    const data = await response.json();

	if ( data ) {
		dispatch({
			type : 'FORGOTTEN_PASSWORD',
			payload : "If you have an account with us, we've sent you a password reset email",
		})
	} else {
		dispatch({
			type : 'FAILED_FORGOTTEN_PASSWORD',
			payload : 'Oops, something went wrong.',
		})
	}
}

export default forgottenPassword;
